import { ArchiveMusicOutlineIcon } from './ArchiveMusicOutlineIcon';

/**
 * author: Colton Wiscombe
 * id B039CC1C-A987-4383-874C-587493FD807D
 * name archive-music-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-music-outline.svg
 * tags
 * - Music 
 */
export const BoxMusicOutlineIcon = ArchiveMusicOutlineIcon;
export default BoxMusicOutlineIcon